<template>
  <section id="in-evidenza">
    <div class="bg-100 py-5">
      <div class="container px-4">
        <div class="row">
          <div class="col">
            <h3 class="mb-4 text-primary">Tutte le pronunce per anno</h3>
          </div>
        </div>
        <div class="row" v-if="getLatestYear()">
          <div class="col-12 col-sm-6 col-lg-4" v-for="item in getLatestYear()" v-bind:key="item.year">
            <!--start card-->
            <article class="card-wrapper card-space" @click="test()">
              <div class="card card-bg card-big rounded shadow">
                <!-- <div class="flag-icon"></div> -->
                <div class="etichetta">
                  <svg class="icon">
                    <use :xlink:href="icons.itCalendar"></use>
                  </svg>
                  <span>{{item.year}}</span>
                  <!-- <a
                      class="read-more"
                      href="https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid/1960">
                      <span class="text">Scarica tutte le pronunce del {{item.year}}</span>
                      <svg class="icon">
                        <use :xlink:href="icons.itArrowRight"></use>
                      </svg>
                    </a> -->
                </div>
                <div class="card-body">
                  <h5 class="card-title">Nel {{item.year}}, la Corte Costituzionale ha pronunciato</h5>
                  <span class="badge badge-pill sentenze-bg">{{item.sentenze}} sentenze</span>
                  <span class="badge badge-pill ordinanze-bg">{{item.ordinanze}} ordinanze</span>
                  <p class="card-text">
                    <button
                      class="btn btn-primary"
                      @click="goToPronunce($event, item.year)">
                        Consulta le pronunce del {{item.year}}
                    </button>
                  </p>
                  <a
                    class="read-more"
                    :href="getGitHubLink(item.year)"
                    target="_blank">
                    <span class="text">Oppure scarica l'intera annata {{item.year}}</span>
                    <svg class="icon">
                      <use :xlink:href="icons.itArrowRight"></use>
                    </svg>
                  </a>
                  <!-- <a class="read-more" href="#" @click="goToPronunce($event, item.year)">
                    <span class="text">Consulta tutte le pronunce del {{item.year}}</span>
                    <svg class="icon">
                      <use :xlink:href="icons.itArrowRight"></use>
                    </svg>
                  </a>
                  <div class="it-card-footer">
                    <a
                      href="https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid/1960">
                      <span class="text">Scarica tutte le pronunce del {{item.year}}</span>
                      <svg class="icon">
                        <use :xlink:href="icons.itGitHub"></use>
                      </svg>
                    </a>
                  </div> -->
                </div>
              </div>
            </article>
            <!--end card-->
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12 col-lg-12">
            <div class="progress-spinner progress-spinner-active">
              <span class="sr-only">Caricamento...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import _ from 'underscore';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'YearCards',
  async beforeMount() {
    if (!this.docPerYear) {
      const docsPerYearJson = await Vue.axios.get(`${Vue.prototype.$proxy}countDocs.xq`);
      const docsPerYear = docsPerYearJson.data.entries;
      this.docPerYear = docsPerYear;
    }

    /* this.docPerYear.forEach(async (entry) => {
      this.$store.dispatch('SAVE_YEAR', entry.year);
    }); */
  },
  mounted() {
    /* this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'ADD_YEAR') {
        this.latestPronunciaPerYear = state;
      }
    }); */
  },
  methods: {
    goToPronunce(e, year) {
      e.preventDefault();
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER')
        .then(() => {
          this.$store.dispatch('SAVE_PRONUNCE_FILTER', {
            type: 'years',
            filters: {
              years: [year],
            },
          }).then(() => {
            this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(() => {
              this.$router.push({ path: '/pronunce' });
            });
          });
        });
    },
    getGitHubLink(year) {
      return `https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid/${year}`;
    },
    getLatestYear() {
      const years = this.docPerYear;
      return years;
    },
    test(years, yearToSearch) {
      const myYear = _.where(years, { year: yearToSearch });
      return myYear;
    },
    getLatestSentenza(years, yearToSearch) {
      const myYear = _.where(years, { year: yearToSearch })[0];
      let latestSentenza = false;
      if (myYear) {
        const latest = myYear.entries.latestSentenza.pronunciaInfo;
        latestSentenza = latest;
      }
      return latestSentenza;
    },
    getLatestOrdinanza(years, yearToSearch) {
      const myYear = _.where(years, { year: yearToSearch })[0];
      let latestOrdinanza = false;
      if (myYear) {
        const latest = myYear.entries.latestOrdinanza.pronunciaInfo;
        latestOrdinanza = latest;
      }
      return latestOrdinanza;
    },
  },
  computed: mapState(['latestPerYear']),
  data() {
    return {
      docPerYear: null,
      // latestPronunciaPerYear: [],
      icons: {
        itCalendar: `${sprites}#it-calendar`,
        itInfoCircle: `${sprites}#it-info-circle`,
        itArrowRight: `${sprites}#it-arrow-right`,
        itGitHub: `${sprites}#it-github`,
      },
    };
  },
};
</script>

<style lang="less" scoped>
  .card-text{
    margin-top:25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/imports/YearCards.vue